module.exports = __webpack_public_path__ + "static/media/sushi.dbd25ee6.png";